import {
    GET_SUPPLIERS,
    GET_SUPPLIERS_LIST_TYPE_DOCUMENT,
    GET_STATE_LOADING
    
} from "@/views/suppliers/store/types/types.js";

const getters = {
    [GET_SUPPLIERS]: state => state.suppliers,
    [GET_SUPPLIERS_LIST_TYPE_DOCUMENT]: state => state.typeSuppliers,
    [GET_STATE_LOADING]: state => state.loading

};

export default getters;